import React, { Component } from "react";
var FormMethods = {
  handleFocus: function handleFocus(e) {
    this.setState({
      active: true
    });
  },
  handleBlur: function handleBlur(e) {
    if (e.target.value === "") {
      this.setState({
        active: false
      });
    }
  },
  handleChange: function handleChange(e) {
    this.setState({
      value: e.target.value
    });
  }
};
export default FormMethods;